<template>
    <div v-loading="loading" class="deposit-refund-detail">
        <header class="deposit-refund-detail__header">
            <button
                class="deposit-refund-detail__back btn btn-sm btn-light"
                type="button"
                @click="goBack"
            >
                <i class="el-icon-arrow-left"></i>
                Quay lại
            </button>
            <h4 class="deposit-refund-detail__title">
                Chi tiết hồ sơ hoàn cọc bổ trợ khách hàng:
                <strong>{{ detail.studentName || "—" }}</strong>
            </h4>
        </header>

        <div v-if="detail.id" class="deposit-refund-detail__layout">
            <section class="deposit-refund-detail__main">
                <el-card class="deposit-refund-detail__card" shadow="never">
                    <h5 class="deposit-refund-detail__section-title">I. Thông tin học viên</h5>
                    <div class="deposit-refund-detail__grid">
                        <div class="deposit-refund-detail__field">
                            <label>Họ tên</label>
                            <div class="deposit-refund-detail__value">{{ detail.studentName || "—" }}</div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Số điện thoại</label>
                            <div class="deposit-refund-detail__value">{{ detail.phone || "—" }}</div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Mã học viên</label>
                            <div class="deposit-refund-detail__value">{{ detail.studentCode || "—" }}</div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Tài khoản ngân hàng</label>
                            <div class="deposit-refund-detail__value deposit-refund-detail__value--with-tip">
                                <span>{{ detail.bankAccountNumber || "—" }}</span>
                                <el-tooltip
                                    v-if="detail.bankAccountNumber"
                                    content="Thông tin tài khoản từ yêu cầu hoàn cọc"
                                    placement="top"
                                >
                                    <span class="deposit-refund-detail__tip">T</span>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Ngân hàng</label>
                            <div class="deposit-refund-detail__value">{{ detail.bankName || "—" }}</div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Chủ tài khoản</label>
                            <div class="deposit-refund-detail__value">{{ detail.bankAccountName || "—" }}</div>
                        </div>
                    </div>

                    <h5 class="deposit-refund-detail__section-title deposit-refund-detail__section-title--spaced">
                        II. Thông tin hồ sơ
                    </h5>
                    <div class="deposit-refund-detail__grid">
                        <div class="deposit-refund-detail__field">
                            <label>Hợp đồng</label>
                            <div class="deposit-refund-detail__value">
                                <router-link
                                    v-if="detail.contractId"
                                    :to="{name: 'contract-index'}"
                                    class="deposit-refund-detail__link"
                                >
                                    {{ detail.contractCode }}
                                </router-link>
                                <span v-else>{{ detail.contractCode || "—" }}</span>
                            </div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Mã lớp chính</label>
                            <div class="deposit-refund-detail__value">{{ detail.mainClassName || "—" }}</div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Mã lớp BTCT 1</label>
                            <div class="deposit-refund-detail__value">
                                {{ detail.supplementaryClass1Name || "—" }}
                            </div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Mã lớp BTCT 2</label>
                            <div class="deposit-refund-detail__value">
                                {{ detail.supplementaryClass2Name || "—" }}
                            </div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Phí cam kết đã đóng</label>
                            <div class="deposit-refund-detail__value">
                                {{ formatCurrency(detail.committedFeeAmount) }}
                            </div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Số buổi vắng</label>
                            <div class="deposit-refund-detail__value">{{ detail.absenceCount }}</div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Số không làm BTVN</label>
                            <div class="deposit-refund-detail__value">{{ detail.homeworkMissingCount }}</div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Tổng số lỗi</label>
                            <div class="deposit-refund-detail__value deposit-refund-detail__value--with-tip">
                                <span>{{ detail.totalErrors }}</span>
                                <el-tooltip
                                    content="Tổng lỗi đã xác nhận tại các lớp bổ trợ cấp tốc"
                                    placement="top"
                                >
                                    <span class="deposit-refund-detail__tip">T</span>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Thời gian cập nhật lỗi mới nhất</label>
                            <div class="deposit-refund-detail__value">
                                {{ detail.latestErrorUpdatedAt || "—" }}
                            </div>
                        </div>
                        <div class="deposit-refund-detail__field">
                            <label>Số tiền cần hoàn lại</label>
                            <div class="deposit-refund-detail__value deposit-refund-detail__value--amount">
                                {{ formatCurrency(detail.refundAmount) }}
                            </div>
                        </div>
                    </div>

                    <footer class="deposit-refund-detail__status-bar">
                        <span class="deposit-refund-detail__status-label">Trạng thái xử lý</span>
                        <span :class="detail.processingStatusClass" class="refund-status-badge">
                            {{ detail.processingStatusLabel }}
                        </span>
                    </footer>
                </el-card>
            </section>

            <aside class="deposit-refund-detail__aside">
                <DepositRefundHistoryTimeline :history="detail.statusHistory"/>
            </aside>
        </div>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {GET_DEPOSIT_REFUND_DETAIL} from "@/core/services/store/deposit-refund/depositRefund.module";
import {DepositRefundDetailModel} from "./model/DepositRefundDetailModel";
import DepositRefundHistoryTimeline from "./component/DepositRefundHistoryTimeline.vue";

export default {
    name: "DepositRefundDetail",
    components: {
        DepositRefundHistoryTimeline,
    },
    data() {
        return {
            loading: false,
            detail: new DepositRefundDetailModel(),
        };
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý tài chính"},
            {title: "Quản lý phí khác", route: "PhiBoTroFeeList"},
            {title: "Phí bổ trợ", route: "PhiBoTroFeeList"},
            {title: "Chi tiết hồ sơ hoàn cọc"},
        ]);
        this.loadDetail();
    },
    methods: {
        formatCurrency(amount) {
            if (amount === null || amount === undefined || amount === "") return "—";
            const num = Number(amount);
            return Number.isNaN(num) ? amount : `${num.toLocaleString("vi-VN")} đ`;
        },
        goBack() {
            this.$router.push({name: "PhiBoTroFeeList"});
        },
        async loadDetail() {
            const id = this.$route.params.id;
            if (!id) {
                this.$message.error("Không tìm thấy hồ sơ hoàn cọc");
                this.goBack();
                return;
            }

            this.loading = true;
            try {
                const res = await this.$store.dispatch(GET_DEPOSIT_REFUND_DETAIL, id);
                if (res?.error) {
                    this.$message.error(res?.message || "Không tải được chi tiết hồ sơ");
                    this.goBack();
                    return;
                }
                const payload = res?.data ?? res;
                this.detail = new DepositRefundDetailModel(payload);
            } catch (error) {
                const message =
                    error?.data?.message || error?.message || "Có lỗi xảy ra khi tải chi tiết hồ sơ";
                this.$message.error(message);
                this.goBack();
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.deposit-refund-detail {
    min-height: calc(100vh - 140px);
    padding: 20px 24px 32px;
    background: #f3f6f9;
    border-radius: 8px;
}

.deposit-refund-detail__header {
    margin-bottom: 20px;
}

.deposit-refund-detail__back {
    margin-bottom: 12px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.deposit-refund-detail__title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #181c32;
    line-height: 1.4;
}

.deposit-refund-detail__title strong {
    color: #181c32;
    font-weight: 700;
}

.deposit-refund-detail__layout {
    display: grid;
    grid-template-columns: minmax(0, 1.45fr) minmax(300px, 1fr);
    gap: 20px;
    align-items: start;
}

.deposit-refund-detail__card {
    border-radius: 10px;
    border: 1px solid #ebedf3;
}

.deposit-refund-detail__card :deep(.el-card__body) {
    padding: 22px 24px 20px;
}

.deposit-refund-detail__section-title {
    margin: 0 0 16px;
    font-size: 14px;
    font-weight: 700;
    color: #181c32;
}

.deposit-refund-detail__section-title--spaced {
    margin-top: 28px;
}

.deposit-refund-detail__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px 24px;
}

.deposit-refund-detail__field label {
    display: block;
    margin-bottom: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #7e8299;
}

.deposit-refund-detail__value {
    min-height: 40px;
    padding: 10px 12px;
    border: 1px solid #e4e6ef;
    border-radius: 6px;
    background: #f9fafb;
    font-size: 13px;
    color: #3f4254;
    line-height: 1.4;
}

.deposit-refund-detail__value--amount {
    font-weight: 700;
    color: #181c32;
}

.deposit-refund-detail__value--with-tip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.deposit-refund-detail__tip {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #1bc5bd;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: help;
}

.deposit-refund-detail__link {
    color: #3699ff;
    font-weight: 600;
    text-decoration: none;
}

.deposit-refund-detail__link:hover {
    text-decoration: underline;
}

.deposit-refund-detail__status-bar {
    margin-top: 24px;
    padding-top: 18px;
    border-top: 1px solid #ebedf3;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.deposit-refund-detail__status-label {
    font-size: 13px;
    font-weight: 600;
    color: #3f4254;
}

.refund-status-badge {
    display: inline-block;
    padding: 6px 14px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
}

.refund-status--need {
    background: #fff4de;
    color: #ffa800;
}

.refund-status--pending {
    background: #e1f0ff;
    color: #3699ff;
}

.refund-status--rejected {
    background: #ffe2e5;
    color: #f64e60;
}

.refund-status--waiting {
    background: #eee5ff;
    color: #8950fc;
}

.refund-status--completed {
    background: #c9f7f5;
    color: #1bc5bd;
}

@media screen and (max-width: 1200px) {
    .deposit-refund-detail__layout {
        grid-template-columns: 1fr;
    }
}

@media screen and (max-width: 768px) {
    .deposit-refund-detail {
        padding: 16px;
    }

    .deposit-refund-detail__grid {
        grid-template-columns: 1fr;
    }
}
</style>
